import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch
} from '@mui/material';

const DetailsStep = ({ formData, setFormData, t }) => {
  const handleChange = (field) => (event) => {
    setFormData(prev => ({ ...prev, [field]: event.target.value }));
  };

  const handleSwitchChange = (field) => (event) => {
    setFormData(prev => ({ ...prev, [field]: event.target.checked }));
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={t('editRoommate.description')}
          value={formData.description}
          onChange={handleChange('description')}
          multiline
          rows={4}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <InputLabel>{t('editRoommate.gender')}</InputLabel>
          <Select
            value={formData.gender}
            onChange={handleChange('gender')}
            label={t('editRoommate.gender')}
          >
            <MenuItem value="201">{t('editRoommate.genderOptions.male')}</MenuItem>
            <MenuItem value="104">{t('editRoommate.genderOptions.female')}</MenuItem>
            <MenuItem value="70">{t('editRoommate.genderOptions.any')}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          label={t('editRoommate.ageRangeStart')}
          type="number"
          value={formData.preferredAgeRangeStart}
          onChange={handleChange('preferredAgeRangeStart')}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          label={t('editRoommate.ageRangeEnd')}
          type="number"
          value={formData.preferredAgeRangeEnd}
          onChange={handleChange('preferredAgeRangeEnd')}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.petsAllowed}
              onChange={handleSwitchChange('petsAllowed')}
            />
          }
          label={t('editRoommate.petsAllowed')}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.smokingAllowed}
              onChange={handleSwitchChange('smokingAllowed')}
            />
          }
          label={t('editRoommate.smokingAllowed')}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.alcoholAllowed}
              onChange={handleSwitchChange('alcoholAllowed')}
            />
          }
          label={t('editRoommate.alcoholAllowed')}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.utilitiesIncluded}
              onChange={handleSwitchChange('utilitiesIncluded')}
            />
          }
          label={t('editRoommate.utilitiesIncluded')}
        />
      </Grid>
    </Grid>
  );
};

export default DetailsStep; 